export default "__VITE_ASSET__sy0U1OT6__"